import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Typography } from '@mui/material';

export function CheckboxWithLabel({ label, nameAndId, handleCheck, checkboxStyles = null }) {
	return (
		<FormGroup>
			<FormControlLabel
				sx={{
					width: 'fit-content',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
				control={<Checkbox sx={checkboxStyles} />}
				label={<Typography variant="body2">{label}</Typography>}
				onChange={handleCheck}
				name={nameAndId}
			/>
		</FormGroup>
	);
}
